import axios from 'axios'
import { updateClient } from 'supporticon/utils/client'

const apiUrls = {
  // For backwards compatibility:
  'production': 'https://everydayhero.com',
  'staging': 'https://everydayhero-staging.com',
  'justgiving': 'https://api.justgiving.com',

  'edh-production': 'https://everydayhero.com',
  'edh-staging': 'https://everydayhero-staging.com',
  'justgiving-production': 'https://api.justgiving.com',
  'justgiving-staging': 'https://api.staging.justgiving.com'
}

export const client = axios.create({ baseURL: apiUrls['edh-production'] })

export const updateEnvironment = (environment = 'edh-production') => {
  const baseURL = apiUrls[environment]
  client.defaults.baseURL = baseURL

  return updateClient({
    baseURL,
    headers: /justgiving/.test(environment) && {
      accept: 'application/json, text/plain, */*',
      'x-api-key': process.env.JG_API_KEY
    }
  })
}

export const isJustGiving = () => /justgiving/.test(client.defaults.baseURL)
export const isStaging = () => /staging/.test(client.defaults.baseURL)



// WEBPACK FOOTER //
// ./lib/environment/index.js